var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kaihu-new"},[_c('kaihu-cmb',{attrs:{"org-info":_vm.userCurrentOrg,"user-id":_vm.userId},on:{"success":_vm.handleSuccess}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }